import api from "./api";

export const buscarTransacciones = async (filtros) => {
    const params = new URLSearchParams();
    if (filtros.numero)
        params.append("numero", filtros.numero);

    if (filtros.fechaDesde)
        params.append("fechaDesde", filtros.fechaDesde);

    if (filtros.fechaHasta)
        params.append("fechaHasta", filtros.fechaHasta);

    if (filtros.estado)
        params.append("estado", filtros.estado);

    if (filtros.filtroFecha)
        params.append("filtroFecha", filtros.filtroFecha);

    if (filtros.prestacion)
        params.append("prestacion", filtros.prestacion);

    const response = await api.get(`/v1/transacciones/buscar?${params.toString()}`);
    return response.data;
};

export const listarEstadosTransaccion = async () => {
    const response = await api.get("/v1/transacciones/estados");
    const grupos = {
        RECHAZADO: { nombre: "NO_AUTORIZADO", preferido: "NO_AUTORIZADO" },
        NO_AUTORIZADO: { nombre: "NO_AUTORIZADO", preferido: "NO_AUTORIZADO" },
        DERIVADO: { nombre: "DERIVADO", preferido: "DERIVADO" },
        DERIVADO_AUDITORIA: { nombre: "DERIVADO", preferido: "DERIVADO" },
    };

    return Array.from((response.data || []).reduce((catalogo, estado) => {
        const nombreOriginal = String(estado.nombre || "").toUpperCase();
        const grupo = grupos[nombreOriginal];
        const nombre = grupo?.nombre || nombreOriginal;
        const existente = catalogo.get(nombre);

        if (!existente || nombreOriginal === grupo?.preferido) {
            catalogo.set(nombre, { ...estado, nombre });
        }
        return catalogo;
    }, new Map()).values());
};
